





















import { GeolocationDetails } from '@/types/geolocation';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class WeatherLocationsPicker extends Vue {
    @Prop() private availableWeatherLocations!: GeolocationDetails[];
    @Prop() private weatherLocation?: GeolocationDetails;
}
